/*  Mobile comparison page — mostra tutti i 9 frame iPhone (3 proposte × 3 ruoli)
    in una griglia, così l'utente vede tutto in un colpo d'occhio.
    Route: /mockup/v2/mobile
*/

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useV2Fonts } from './_shared';
import MobileView from './MobileView';
import { Smartphone } from 'lucide-react';

const ROLES = [
  { id: 'fo', label: 'Front Office', desc: 'apertura ticket rapida + stato dei propri' },
  { id: 'hk', label: 'Housekeeping', desc: 'camere assegnate, stato pulizia, segnala guasto' },
  { id: 'tech', label: 'Tecnico', desc: 'prossimo intervento, coda, foto + scan QR' },
];

const PROPOSALS = [
  { id: 'a', name: 'Operational', tag: 'Light · Brutalist' },
  { id: 'b', name: 'Boutique', tag: 'Warm · Premium' },
  { id: 'c', name: 'Data Intel', tag: 'Dark · Tactical' },
];

const MobileIndex = () => {
  useV2Fonts();
  const [role, setRole] = useState('fo');

  return (
    <div className="min-h-screen bg-neutral-100 text-neutral-900" data-testid="mockup-v2-mobile-index">
      <header className="bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-500 mb-1">
              <Smartphone className="w-3.5 h-3.5" /> Mobile preview · 9 schermate
            </div>
            <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: '"Space Grotesk", system-ui' }}>
              Come renderebbero su telefono
            </h1>
            <p className="text-sm text-neutral-500 mt-1">
              3 ruoli operativi × 3 direzioni visive. Scegli il ruolo da confrontare e guarda le 3 proposte affiancate.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/mockup/v2"
              className="text-xs text-neutral-500 hover:text-neutral-900 underline underline-offset-4"
              data-testid="back-to-v2-index"
            >
              ← Desktop
            </Link>
            <Link
              to="/mockup"
              className="text-xs text-neutral-500 hover:text-neutral-900 underline underline-offset-4"
            >
              Mockup v1
            </Link>
          </div>
        </div>

        {/* Role switcher */}
        <div className="max-w-7xl mx-auto px-6 pb-4 flex items-center gap-2">
          <span className="text-xs uppercase tracking-widest text-neutral-500 mr-2">Ruolo:</span>
          {ROLES.map((r) => (
            <button
              key={r.id}
              onClick={() => setRole(r.id)}
              data-testid={`role-tab-${r.id}`}
              className="px-4 py-1.5 text-sm font-medium rounded-full transition-colors"
              style={{
                background: role === r.id ? '#111' : 'transparent',
                color: role === r.id ? '#fff' : '#525252',
                border: role === r.id ? 'none' : '1px solid #E5E5E5',
              }}
            >
              {r.label}
            </button>
          ))}
          <span className="text-xs text-neutral-500 ml-3 hidden md:inline">
            · {ROLES.find((r) => r.id === role).desc}
          </span>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-items-center">
          {PROPOSALS.map((p) => (
            <div key={p.id} className="flex flex-col items-center gap-4">
              <MobileView proposalId={p.id} role={role} />
              <div className="text-center mt-1">
                <div className="text-sm font-semibold" style={{ fontFamily: '"Space Grotesk", system-ui' }}>
                  Proposta {p.id.toUpperCase()} · {p.name}
                </div>
                <div className="text-xs text-neutral-500 mt-0.5">{p.tag}</div>
                <Link
                  to={`/mockup/v2/${p.id}`}
                  className="inline-block mt-2 text-xs text-blue-600 hover:underline underline-offset-2"
                  data-testid={`open-desktop-${p.id}`}
                >
                  Vedi versione desktop →
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 p-5 bg-white border border-neutral-200 rounded-md text-sm text-neutral-600">
          <strong className="text-neutral-900">Note di valutazione mobile.</strong>{' '}
          Tutte e tre le proposte mantengono lo stesso schema mobile-first: <em>header sticky · contenuto scrollabile · tab bar con CTA centrale rilevata</em>.
          La differenza è nell&apos;identità visiva (forma, ombra, tipografia, contrasto), non nella struttura UX —
          così cambi il &laquo;vestito&raquo; ma non l&apos;ergonomia.
        </div>
      </main>
    </div>
  );
};

export default MobileIndex;
